<template>
  <div class="hello">
    <h1>NEWS</h1>
    <hr />
    <div v-for="(news, index) in listNews" v-bind:key="index">
      <div class="news">
        <p class="type">{{ news.type }}</p>
        <p class="description" v-html="news.description"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "News",
  data() {
    return {
      listNews: [
        {
          type: "RELEASE",
          description: `We just released "<a href='https://www.youtube.com/watch?v=arhg3uP_Kf0' target='_blank'>Cold, Damp & Sour</a>", our first EP since the line-up changed. It's the result of many months of work, and we hope you'll have a good time listening to it. If you did, please share it around you, it helps a lot !`,
        },
        {
          type: "CLIP",
          description: `Following the release of our EP, we are proud to show you a <a href='https://www.youtube.com/watch?v=0Vrt632YlmI' target='_blank'>video clip</a> for the first track "Around the fire". `,
        },
        {
          type: "BAND",
          description:
            "We're looking for some places to play our music. If you're interrested, please <a href='mailto:contact@voidshelter.com' target='_blank'>contact us<\a> !",
        },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.news {
  display: flex;
}
.hello {
  padding: 50px 30px;
  margin: 0 auto;
  max-width: 1200px;
  color: white;
}

.news > p {
  margin-bottom: 0px;
}

.type {
  font-weight: bold;
  width: 40px;
}

.description {
  margin-left: 20px;
  width: 90%;
  text-align: left;
}

.type {
  padding: 0;
}
</style>
